import { AbstractFault, Fault } from "./fault";

/**
 * @summary Represents an ArgumentNullFault
 */
@Fault('Modutecture.Shared.Http.ArgumentNullFault, Modutecture.Shared')
export class ArgumentNullFault extends AbstractFault {  
  public paramName: string;
}